









import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

import { DragSource } from "vue-react-dnd";

/**
 * Utils
 */

const DragSourceImpl = {
	dragSource: {
		type() {
			const that = this as any as DragItem;
			return that.type;
		},
		specs: {
			beginDrag() {
				return this;
			},

			endDrag(monitor: any) {
				const didDrop = monitor.didDrop();

				if (!didDrop) {
					const that = this as any as DragItem;
					that.onDrop(that.data, that.parentIndex);
				}
			}
		},
		collect(connect: any, monitor: any) {
			const that = this as any as DragItem;

			that.isDragging = monitor.isDragging();
		}
	}
};


/**
 * Draggable item component.
 */
@Component({
	mixins: [DragSource, DragSourceImpl]
})
export default class DragItem extends Vue {
	@Prop({ default: "" })
	type!: string;

	@Prop()
	onDrop!: (data: any, previousParentIndex: any) => void;

	@Prop({ type: Boolean })
	isActive!: boolean;

	@Prop({ type: Boolean })
	isCopyable!: boolean;

	@Prop()
	data!: any;

	@Prop()
	parentIndex!: string;

	/// Attributes
	isDragging = false;
}
